import styled from 'styled-components';

export const SquareMeterInputContainer = styled.div`
  display: flex;
  align-items: center;
  width: ${(props) => (props.fullWidth ? '100%' : '120px')};
  position: relative;
`;

export const SquareMeterInput = styled.input`
  font-family: 'Spectral-Regular', serif;
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #283618;
  font-size: 0.875rem;
  color: #283618;
  padding-right: 2rem; /* Deja espacio a la derecha para el m² */

  &::placeholder {
    color: #283618;
  }

  &:focus {
    outline: none;
    border-color: #283618;
  }
`;

export const SquareMeterLabel = styled.span`
  position: absolute;
  right: 0.75rem;
  color: #283618;
  font-size: 0.875rem;
`;
